// extracted by mini-css-extract-plugin
export var extras = "workhero-module--extras--5ufVV";
export var heroImage = "workhero-module--hero-image--3iD2v";
export var sidekickImage = "workhero-module--sidekick-image--9ElU9";
export var textWrap = "workhero-module--text-wrap--zaT33";
export var videoWrapWrap = "workhero-module--video-wrap-wrap--JmEqc";
export var workHero = "workhero-module--work-hero--JYJ91";